import React from "react"
import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import Button from "../common/Button"

export default function Hero() {
  return (
    <section className="relative h-screen min-h-[650px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/images/hero.jpg"
          alt="Centre de bien-être spa de luxe"
          className="w-full h-full object-cover"
          loading="eager"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black/55" />
      </div>

      {/* Hero Content */}
      <div className="relative z-10 w-full">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl">
            {/* Subtitle */}
            <motion.span
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              className="inline-block text-[#d6b57b] uppercase tracking-[5px] text-sm md:text-base font-medium mb-6"
            >
              Bien-être et Détente de Luxe
            </motion.span>

            {/* Title */}
            <motion.h1
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9 }}
              className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-tight text-white"
            >
              Reconnectez votre corps,
              <span className="block text-[#d6b57b]">
                Esprit et âme
              </span>
            </motion.h1>

            {/* Description */}
            <motion.p
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.1 }}
              className="mt-8 text-base md:text-lg lg:text-xl text-gray-200 leading-relaxed max-w-2xl"
            >
              Découvrez des massages relaxants, des rituels de hammam, des soins du visage, une piscine intérieure chauffée et un espace de remise en forme conçus pour restaurer l'équilibre, le bien-être et la sérénité.
            </motion.p>

            {/* Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.3 }}
              className="flex flex-col sm:flex-row gap-4 mt-10"
            >
              <Button
                to="/services"
                size="lg"
                variant="primary"
                ariaLabel="Explore spa services"
              >
                Explorer les services
              </Button>

              <Button
                href="https://wa.me/21697902051"
                size="lg"
                variant="outline"
                ariaLabel="Réservez votre rendez-vous au spa via WhatsApp"
              >
                Prendre rendez-vous
              </Button>
            </motion.div>

            {/* Features */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1.5 }}
              className="grid grid-cols-2 sm:grid-cols-3 gap-6 mt-16"
            >
              <div>
                <h3 className="text-3xl font-bold text-[#d6b57b]">
                  10+
                </h3>

                <p className="text-gray-300 text-sm mt-2">
                  Années d'expérience
                </p>
              </div>

              <div>
                <h3 className="text-3xl font-bold text-[#d6b57b]">
                  5K+
                </h3>

                <p className="text-gray-300 text-sm mt-2">
                  Clients Satisfaits
                </p>
              </div>

              <div>
                <h3 className="text-3xl font-bold text-[#d6b57b]">
                  100%
                </h3>

                <p className="text-gray-300 text-sm mt-2">
                  Relaxation Garantie
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <Link
          to="/services"
          aria-label="Faites défiler jusqu'aux services"
          className="flex flex-col items-center text-white animate-bounce"
        >
          <span className="text-xs uppercase tracking-[3px] mb-2">
            Scroll
          </span>

          <div className="w-[1px] h-10 bg-white/70" />
        </Link>
      </div>
    </section>
  )
}